import { render, staticRenderFns } from "./feature_library_modal.vue?vue&type=template&id=8b06f3d6"
import script from "./feature_library_modal.vue?vue&type=script&lang=js"
export * from "./feature_library_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports